import React from 'react'
import axios from 'axios'
import qs from 'qs'
import { CellsTitle, Cells, Cell, CellBody, CellFooter, Toast, Dialog } from 'react-weui'
import { browserHistory } from 'react-router'
import { updateSuccess, delSuccess } from '../../utils/connectApp'
import { isLZWKAPP, storage } from '../../utils'
import config from '../../config'
import '../../css/page/ChannelLectureEditPage.css'
import Page from "../../components/Page";


class LectureEditPage extends React.Component {
    constructor (props) {
        super(props)
        this.isHasHTML = false
        this.state = {
            lecture: null,
            alertDialog: {
                isShow: false,
                text: '',
            },
            isShowMode: false,
            isShowNoEnterDialog: false,
            isShowConfirmDialog: false,
        }
    }
    componentDidMount () {
        document.title = '编辑课程'
        const isShowModeCache = storage.getItem('lectrue_edit_is_show_mode')
        if (isShowModeCache != null) {
            this.setState({ isShowMode: isShowModeCache })
        }
        this.fetchData()
        updateSuccess({
            type: 'lecture'
        })

        //风控
        // this.page.showFengKongTip()
    }
    fetchData () {
        axios.get(`/api/lecture/${this.props.params.id}/info`)
            .then(res => {
                const desc = res.data.data.lecture.description
                this.isHasHTML = /Powered-by-XIUMI/.test(desc)
                this.setState({
                    lecture: res.data.data,
                    isShowMode: res.data.data.lecture.lecture_mode === 'default',
                })
                storage.setItem('lectrue_edit_is_show_mode', res.data.data.lecture.lecture_mode === 'default')
            })
    }
    onClickAlertOk () {
        this.setState({ alertDialog: { isShow: false } })
        if (isLZWKAPP()) {
            delSuccess({
                type: 'lecture'
            })
        } else {
            location.assign(`/liveroom/${this.state.lecture.liveroom.id}`)
        }
    }
    onClickCloseOk () {
        this.setState({ isPending: true, isShowConfirmDialog: false })
        axios.post(`/api/lecture/${this.props.params.id}/edit`, qs.stringify({
            status: 'draft',
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return alert(res.data.msg)
                }
                this.setState({
                    alertDialog: { isShow: true, text: '下架成功' }
                })
            })
    }
    onClickDesc () {
        if (this.isHasHTML) {
            this.setState({ isShowNoEnterDialog: true })
        } else {
            location.assign(`/lecture/${this.props.params.id}/edit/desc`)
        }
    }
    renderDesc() {
        if (this.state.lecture) {
            if (this.state.lecture.lecture.lecture_type === 'pay_channel') {
                if (this.state.lecture.lecture.lecture_mode !== 'default') {
                    return <CellLink onClickFn={() => this.onClickDesc()} title='课程讲稿'/>
                }
            }
        }
        return <CellLink onClickFn={() => this.onClickDesc()} title='介绍内容'/>
    }
    render() {
        const lectureId = this.props.params.id
        return (
            <Page parent={this}>
                <div className="wk-inner-page channel-lecture-edit-page">
                    <CellsTitle>编辑课程</CellsTitle>
                    <Cells>
                        <CellLink link={`/lecture/${lectureId}/edit/title`} title='标题' />
                        <CellLink link={`/lecture/${lectureId}/edit/category`} title='课程分类' />
                        <CellLink link={`/lecture/${lectureId}/edit/cover`} title='自定义封面图' />
                        {this.renderDesc()}
                        <CellLink link={`/lecture/${lectureId}/edit/pay`} title='加密与付费' />
                        <CellLink link={`/lecture/${lectureId}/edit/time`} title='开课时间' />
                        <CellLink 
                          link={`/lecture/${lectureId}/edit/channel`} 
                          query={{ liveroom_id: this.state.lecture ? this.state.lecture.liveroom.id : '' }}
                          title='所属专栏' 
                        />
                        {this.state.isShowMode && <CellLink link={`/lecture/${lectureId}/edit/mode`} title='使用课件' />}
                        <CellLink link={`/lecture/${lectureId}/edit/reward`} title='打赏设置' />
                        <CellLink link={`/lecture/${lectureId}/edit/priority`} title='课程优先级' />
                        <CellLink onClickFn={e => this.setState({ isShowConfirmDialog: true })} title='下架' isHideAccess={true} />
                    </Cells>
                    <p className="intro">
                        电脑使用谷歌浏览器打开 {config.ADMIN_BASE_URL} 可以使用更强大的编辑功能。
                    </p>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                {/* 提示框 */}
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickAlertOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                {/* 不能进入框 */}
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.setState({ isShowNoEnterDialog: false }) }
                ]} show={this.state.isShowNoEnterDialog}>
                    此介绍含有富文本模版内容，请到讲师管理后台进行编辑（{config.ADMIN_BASE_URL}）
                </Dialog>
                {/* 下架确认框 */}
                <Dialog type="ios" title='' buttons={[
                    { label: '取消', type: 'default', onClick: () => this.setState({ isShowConfirmDialog: false }) },
                    { label: '确定', onClick: () => this.onClickCloseOk() },
                ]} show={this.state.isShowConfirmDialog}>
                    课程下架后，可到讲师管理后台（{config.ADMIN_BASE_URL}）重新上架、编辑和删除。确定下架吗？
                </Dialog>
            </Page>
        )
    }
}


function CellLink (props) {
    const { link, query } = props
    const access = props.isHideAccess ? { access: false } : { access: true }
    const onClickFn = props.link ? () => browserHistory.push({pathname: link, query }) : props.onClickFn
    return (
        <Cell onClick={onClickFn} {...access}>
            <CellBody>
                {props.title}
            </CellBody>
            <CellFooter>
                {props.desc || ''}
            </CellFooter>
        </Cell>
    )
}

export default LectureEditPage



// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditPage.js